module.exports = __webpack_public_path__ + "img/407.e9027188.png";